/* Greenhouse theme — light interactions only */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Mobile menu
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var menu = document.getElementById('mobile-menu');
    if (!menu) return;
    var open = menu.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Sticky header shadow
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Announcement pills: cycle messages, and slide the scroll-triggered one in
  document.querySelectorAll('[data-announce]').forEach(function (pill) {
    var msgs = pill.querySelectorAll('.announce__msg');

    if (pill.hasAttribute('data-announce-scroll')) {
      if (reduce || !('IntersectionObserver' in window)) {
        pill.classList.add('is-out');
      } else {
        var po = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              pill.classList.add('is-out');
              po.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -12% 0px' });
        // the pill sits fully off-screen, so watch its section instead
        po.observe(pill.closest('section') || pill.parentElement || pill);
      }
    }

    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, 6000);
    }
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Variant picker
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    if (!select) return;
    var priceEl = document.querySelector('[data-price]');
    var button = form.querySelector('[data-add]');
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (button) {
        var sold = opt.dataset.available === 'false';
        button.disabled = sold;
        button.textContent = sold ? (button.getAttribute('data-sold-text') || 'Sold out') : (button.getAttribute('data-add-text') || 'Add to cart');
      }
    });
  });

  // Section headings — two styles, picked in theme settings
  var headings = document.querySelectorAll('.page-hero h1, .page-hero h2, .section h1, .section h2, .split__text h2, .statement__line, .faq-cta h2');
  var headingStyle = document.body.classList.contains('headings-rise') ? 'rise'
                   : document.body.classList.contains('headings-none') ? 'none' : 'bounce';

  if (!reduce && headingStyle !== 'none') {
    headings.forEach(function (el) {
      if (el.children.length) return;
      var text = el.textContent.replace(/\s+/g, ' ').trim();
      el.textContent = '';
      // headings inside pasted description text always rise; the hop is for real titles
      var style = el.closest('.rte') ? 'rise' : headingStyle;

      if (style === 'rise') {
        // words masked, then swung up from below the baseline
        text.split(' ').forEach(function (word, i) {
          var outer = document.createElement('span');
          outer.className = 'rise';
          var inner = document.createElement('span');
          inner.textContent = word;
          inner.style.setProperty('--d', (i * 0.09).toFixed(3) + 's');
          outer.appendChild(inner);
          el.appendChild(outer);
          if (i < text.split(' ').length - 1) el.appendChild(document.createTextNode(' '));
        });
      } else {
        // letters stay put, then hop through from first to last
        var n = 0;
        text.split(' ').forEach(function (word, w, words) {
          var wrap = document.createElement('span');
          wrap.style.display = 'inline-block';
          wrap.style.whiteSpace = 'nowrap';
          word.split('').forEach(function (ch) {
            var s = document.createElement('span');
            s.className = 'hop';
            s.textContent = ch;
            s.style.setProperty('--d', (n * 0.045).toFixed(3) + 's');
            wrap.appendChild(s);
            n++;
          });
          el.appendChild(wrap);
          if (w < words.length - 1) { el.appendChild(document.createTextNode(' ')); n += 1; }
        });
      }
    });

    if ('IntersectionObserver' in window) {
      var ho = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            ho.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -14% 0px' });
      headings.forEach(function (el) { ho.observe(el); });
    } else {
      headings.forEach(function (el) { el.classList.add('in'); });
    }
  }


  // Pigeons: each bird keeps its own schedule, so arrivals trickle rather than batch
  document.querySelectorAll('.pigeonholes').forEach(function (unit) {
    if (reduce) return;
    var base = (parseFloat(unit.getAttribute('data-pigeon-gap')) || 26) * 1000;
    var perBird = base / 2;          // three birds sharing the rate
    var perched = 0;                 // only one bird sits on the shelf at a time

    function rand(lo, hi) { return lo + Math.random() * (hi - lo); }

    function fly(n) {
      unit.classList.remove('f' + n, 'c' + n, 'r' + n);

      var roll = Math.random();
      var flight = 7600;
      if (roll < 0.14) {
        unit.classList.add('c' + n);                     // collects on the way out
        flight = 7800;
      } else if (roll < 0.42 && !perched) {
        unit.classList.add('r' + n);                     // settles a while
        perched = n;
        flight = 11400;
        setTimeout(function () { if (perched === n) perched = 0; }, flight);
      }

      void unit.getBoundingClientRect().width;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { unit.classList.add('f' + n); });
      });

      // this bird comes back on its own clock, unrelated to the others
      setTimeout(function () { fly(n); }, flight + rand(perBird * 0.5, perBird * 1.6));
    }

    function start() {
      // open with one bird, then bring the others in well apart, so the first
      // minute has the same loose rhythm as the rest of the time
      [1, 2, 3].forEach(function (n) {
        var first = rand(900, 2600) + (n - 1) * rand(perBird * 0.9, perBird * 1.7);
        setTimeout(function () { fly(n); }, first);
      });
    }

    if ('IntersectionObserver' in window) {
      var po = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { start(); po.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      po.observe(unit);
    } else { start(); }
  });


  // Rockets: a launch now and then, like the pigeons
  document.querySelectorAll('.ship').forEach(function (ship) {
    if (reduce) return;
    var gap = (parseFloat(ship.getAttribute('data-ship-gap')) || 30) * 1000;
    function rand(lo, hi) { return lo + Math.random() * (hi - lo); }
    function launch() {
      ship.classList.remove('launch');
      void ship.getBoundingClientRect().width;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { ship.classList.add('launch'); });
      });
      setTimeout(launch, Math.max(gap * rand(0.7, 1.4), 12000));
    }
    if ('IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { setTimeout(launch, rand(1200, 3000)); so.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      so.observe(ship);
    } else { setTimeout(launch, 1500); }
  });


  // Fish: a splash where it breaks the surface on the way out, a bigger one where it dives back in
  document.querySelectorAll('.fish-lane').forEach(function (lane) {
    if (reduce) return;
    var hop = lane.querySelector('.fish-hop');
    var track = lane.querySelector('.fish-track');
    if (!hop || !track) return;
    var cross = parseFloat(getComputedStyle(lane).getPropertyValue('--cross')) || 5;
    var cycle = cross * 1000 / 3.1;

    function splash(size) {
      var laneBox = lane.getBoundingClientRect();
      var fishBox = track.getBoundingClientRect();
      var s = document.createElement('div');
      s.className = 'splash' + (size === 'small' ? ' splash--small' : '');
      s.style.left = (fishBox.left - laneBox.left + fishBox.width / 2) + 'px';
      s.innerHTML = '<i></i><i></i><i></i><i></i><i></i>';
      lane.appendChild(s);
      setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 750);
    }
    function schedule() {
      setTimeout(function () { splash('small'); }, cycle * 0.14);   // breaking out
      setTimeout(function () { splash('big'); },   cycle * 0.86);   // diving in
    }
    schedule();
    hop.addEventListener('animationiteration', schedule);
  });


  // ---------- product page ----------
  var pform = document.querySelector('form.product__form');
  if (pform) {
    var variants = JSON.parse(document.querySelector('[data-variants]').textContent);
    var moneyFmt = JSON.parse(document.querySelector('[data-money]').textContent);
    var idInput = pform.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var addBtn = pform.querySelector('[data-add]');
    var addLabel = pform.querySelector('[data-add-label]');
    var stockEl = pform.querySelector('[data-stock]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyAdd = document.querySelector('[data-sticky-add]');

    function money(cents) {
      var s = (cents / 100).toFixed(2);
      return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, s.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
                     .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                     .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, s.replace('.', ','));
    }
    function selected() {
      var opts = [];
      pform.querySelectorAll('.opt').forEach(function (fs) {
        var on = fs.querySelector('input:checked'); opts.push(on ? on.value : null);
      });
      return opts;
    }
    function find(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      })[0];
    }
    function paint() {
      var opts = selected();
      var v = find(opts);
      pform.querySelectorAll('.opt').forEach(function (fs, i) {
        var lbl = fs.querySelector('[data-opt-value]'); var on = fs.querySelector('input:checked');
        if (lbl && on) lbl.textContent = '\u2014 ' + on.value;
        // grey out values that give no purchasable variant with the other choices held
        fs.querySelectorAll('input').forEach(function (inp) {
          var trial = opts.slice(); trial[i] = inp.value;
          var hit = variants.filter(function (vv) { return trial.every(function (o, k) { return o === null || vv.options[k] === o; }); })[0];
          inp.nextElementSibling.classList.toggle('is-unavailable', !hit || !hit.available);
        });
      });
      if (!v) return;
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.hidden = false; compareEl.textContent = money(v.compare_at_price); }
      else compareEl.hidden = true;
      addBtn.disabled = !v.available; if (stickyAdd) stickyAdd.disabled = !v.available;
      addLabel.textContent = v.available ? (addLabel.getAttribute('data-add-text') || 'Add to cart') : (addLabel.getAttribute('data-sold-text') || 'Sold out');
      stockEl.className = 'product__stock' + (v.available ? (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5 ? ' is-low' : '') : ' is-out');
      var low = v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5;
      stockEl.textContent = v.available ? (low ? (stockEl.getAttribute('data-low-stock') || 'Only [count] left').replace('[count]', v.inventory_quantity) : (stockEl.getAttribute('data-in-stock') || 'In stock and ready to send')) : (stockEl.getAttribute('data-sold-out') || 'Sold out');
      if (v.featured_media) {
        var t = document.querySelector('[data-thumb][data-media-id="' + v.featured_media.id + '"]'); if (t) t.click();
      }
      if (typeof bundlePaint === 'function') bundlePaint();
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }
    pform.querySelectorAll('[data-option-input]').forEach(function (i) { i.addEventListener('change', paint); });

    // bundle tiers and add-ons, sitting under the options
    var tiers = pform.querySelector('[data-bundle]');
    var savedEl = document.querySelector('[data-bundle-saved]');
    var qtyInput = pform.querySelector('[data-bundle-qty]');

    function bundlePaint() {
      var v = find(selected()) || variants[0];
      if (!v) return;
      var tier = tiers && tiers.querySelector('[data-tier]:checked');
      var qty  = tier ? parseInt(tier.value, 10) : (parseInt(qtyInput && qtyInput.value, 10) || 1);
      var pct  = tier ? (parseInt(tier.getAttribute('data-pct'), 10) || 0) / 100 : 0;

      var full  = v.price * qty;
      var total = Math.round(full * (1 - pct));
      var saved = full - total;

      var withAddons = total;
      document.querySelectorAll('[data-addon]:checked').forEach(function (a) {
        withAddons += parseInt(a.getAttribute('data-price'), 10) || 0;
      });

      if (qtyInput) qtyInput.value = qty;
      priceEl.textContent = money(withAddons);
      if (stickyPrice) stickyPrice.textContent = money(withAddons);
      if (savedEl) { savedEl.hidden = saved <= 0; savedEl.textContent = (savedEl.getAttribute('data-label') || 'You save') + ' ' + money(saved); }

      // every tier card re-prices against the variant that is chosen
      if (tiers) tiers.querySelectorAll('[data-tier]').forEach(function (t) {
        var q = parseInt(t.value, 10);
        var p = (parseInt(t.getAttribute('data-pct'), 10) || 0) / 100;
        var tt = Math.round(v.price * q * (1 - p));
        var box = t.nextElementSibling;
        var pe = box && box.querySelector('.tier__price');
        var ee = box && box.querySelector('.tier__each');
        if (pe) pe.textContent = money(tt);
        if (ee) ee.textContent = money(Math.round(tt / q)) + ' each';
      });
    }

    if (tiers) tiers.addEventListener('change', bundlePaint);
    pform.querySelectorAll('[data-addon]').forEach(function (a) { a.addEventListener('change', bundlePaint); });
    if (qtyInput) qtyInput.addEventListener('change', bundlePaint);
    pform.querySelectorAll('[data-option-input]').forEach(function (i) { i.addEventListener('change', bundlePaint); });

    // chosen add-ons ride along as extra line items
    pform.addEventListener('submit', function () {
      document.querySelectorAll('[data-addon]:checked').forEach(function (a, i) {
        [['id', a.value], ['quantity', 1]].forEach(function (pair) {
          var inp = document.createElement('input');
          inp.type = 'hidden'; inp.name = 'items[' + (i + 1) + '][' + pair[0] + ']'; inp.value = pair[1];
          pform.appendChild(inp);
        });
      });
    });
    if (tiers || document.querySelector('[data-addon]')) bundlePaint();


    // sticky gallery: never pin it so that its thumbnails are below the fold
    var media = document.querySelector('.product__media');
    function stick() {
      if (!media) return;
      var h = media.offsetHeight, view = window.innerHeight, headroom = 96, foot = 24;
      var top = (h + headroom + foot <= view) ? headroom : (view - h - foot);
      media.style.setProperty('--stick', Math.round(top) + 'px');
    }
    stick();
    addEventListener('resize', stick);
    document.querySelectorAll('[data-thumb], [data-stage-img]').forEach(function (el) { el.addEventListener('load', stick, true); });
    if ('ResizeObserver' in window && media) new ResizeObserver(stick).observe(media);

    // gallery
    var stage = document.querySelector('[data-stage]'); var stageImg = document.querySelector('[data-stage-img]');
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (stageImg && stageImg.src !== t.getAttribute('data-src')) {
          stageImg.classList.remove('stage-swap'); void stageImg.offsetWidth;
          stageImg.src = t.getAttribute('data-src'); stageImg.classList.add('stage-swap');
        }
      });
    });
    if (stage) stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      stage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
      stage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
    });

    // sticky bar: shows once the real button has scrolled off the top
    var bar = document.querySelector('[data-stickybar]');
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var off = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', off); bar.setAttribute('aria-hidden', off ? 'false' : 'true');
        });
      }, { threshold: 0 }).observe(addBtn);
      if (stickyAdd) stickyAdd.addEventListener('click', function () { addBtn.click(); });
    }
    // copy link
    var copy = document.querySelector('[data-copy-link]');
    if (copy) copy.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(function () { var was = copy.textContent; copy.textContent = copy.getAttribute('data-copied-text') || 'Copied'; setTimeout(function () { copy.textContent = was; }, 1600); });
    });
  }

  // Recommendations: fetched after load so the page never waits on them
  var recs = document.querySelector('[data-recs]');
  if (recs && recs.getAttribute('data-url')) {
    fetch(recs.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = d.querySelector('[data-recs]');
      if (!inner) return;
      // only swap in the fetched row if it has at least as many cards as what is already there
      var now = recs.querySelectorAll('.card').length;
      var next = inner.querySelectorAll('.card').length;
      if (next >= now && next > 0) { recs.innerHTML = inner.innerHTML; wakeUp(recs); }
    }).catch(function () {});
  }


  // Watering can: tips and pours over the line every so often
  document.querySelectorAll('.canpour').forEach(function (can) {
    if (reduce) return;
    var gap = (parseFloat(can.getAttribute('data-pour-gap')) || 20) * 1000;
    function rand(lo, hi) { return lo + Math.random() * (hi - lo); }
    function pour() {
      can.classList.remove('pour'); void can.getBoundingClientRect().width;
      requestAnimationFrame(function () { requestAnimationFrame(function () { can.classList.add('pour'); }); });
      setTimeout(pour, 4400 + gap * rand(0.6, 1.5));
    }
    if ('IntersectionObserver' in window) {
      var co = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { setTimeout(pour, rand(1200, 3000)); co.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      co.observe(can);
    } else setTimeout(pour, 2000);
  });


  // Delivery van: drives the bottom line of its section every so often
  document.querySelectorAll('.van-lane').forEach(function (lane) {
    if (reduce) return;
    var gap = (parseFloat(lane.getAttribute('data-van-gap')) || 35) * 1000;
    var cross = (parseFloat(getComputedStyle(lane).getPropertyValue('--cross')) || 9) * 1000;
    function rand(lo, hi) { return lo + Math.random() * (hi - lo); }
    function drive() {
      lane.classList.remove('run'); void lane.getBoundingClientRect().width;
      requestAnimationFrame(function () { requestAnimationFrame(function () { lane.classList.add('run'); }); });
      setTimeout(drive, cross + gap * rand(0.6, 1.5));
    }
    if ('IntersectionObserver' in window) {
      var vo = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { setTimeout(drive, rand(1500, 4000)); vo.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      vo.observe(lane);
    } else setTimeout(drive, 2000);
  });

  // Edge trace: one lap of fixed length, repeating on its own interval
  document.querySelectorAll('.worm').forEach(function (worm) {
    var cycle = (parseFloat(worm.getAttribute('data-worm-cycle')) || 45) * 1000;
    var repeat = worm.getAttribute('data-worm-repeat') !== 'false';
    var lap = 4200;
    var timer = null;

    function run() {
      worm.classList.remove('run');
      void worm.getBoundingClientRect().width;   // force the reflow
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { worm.classList.add('run'); });
      });
    }

    function start() {
      run();
      if (repeat && !timer) {
        timer = setInterval(run, Math.max(cycle, lap + 1000));
      }
    }

    if (reduce) return;
    if ('IntersectionObserver' in window) {
      var wo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
            wo.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      wo.observe(worm.parentElement || worm);
    } else {
      start();
    }
  });


  // Peek grid: size the box to one full row plus a slice of the next, until it is opened
  document.querySelectorAll('[data-peek].grid-peek--on').forEach(function (box) {
    var grid = box.querySelector('.product-grid');
    var more = box.parentNode.querySelector('[data-peek-open]');
    if (!grid || !grid.firstElementChild) return;
    function cols() { return getComputedStyle(grid).gridTemplateColumns.split(' ').length; }
    var opened = false;
    function label() {
      if (!more) return;
      more.textContent = opened ? (more.getAttribute('data-close-label') || 'Show fewer') : (more.getAttribute('data-open-label') || 'See the rest');
      more.setAttribute('aria-expanded', opened ? 'true' : 'false');
    }
    function size() {
      if (grid.children.length <= cols()) { box.classList.add('is-open'); box.style.maxHeight = 'none'; if (more) more.hidden = true; return; }
      if (opened) { box.classList.add('is-open'); box.style.maxHeight = 'none'; return; }
      var first = grid.firstElementChild;
      var gap = parseFloat(getComputedStyle(grid).rowGap) || 20;
      box.classList.remove('is-open');
      box.style.maxHeight = Math.round(first.offsetHeight + gap + first.offsetHeight * 0.36) + 'px';
    }
    size(); label();
    window.addEventListener('resize', size);
    if (more) more.addEventListener('click', function () {
      opened = !opened;
      size(); label();
      // when closing, bring the top of the grid back into view so the page does not jump away
      if (!opened) {
        var top = box.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 90, behavior: 'smooth' });
      }
    });
  });

  // One-time reveal as grids come into view
  var targets = document.querySelectorAll('.reveal, .step');
  var linePieces = document.querySelectorAll('.branch, .lamp, .deco');
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    targets.forEach(function (el) { io.observe(el); });

    // Line pieces fire only once the piece itself is well inside the viewport,
    // so the growth happens while you're actually looking at that line.
    var lo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          lo.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    linePieces.forEach(function (el) { lo.observe(el); });
  } else {
    targets.forEach(function (el) { el.classList.add('in'); });
    linePieces.forEach(function (el) { el.classList.add('in'); });
  }

  // The theme editor swaps in freshly rendered HTML when a setting changes, and
  // that new markup never met the observers above — anything that starts hidden
  // would stay hidden. Re-run the pieces for whichever section was re-rendered.
  function wakeUp(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('.reveal, .step, .branch, .lamp, .deco').forEach(function (el) {
      el.classList.add('in');
    });
    root.querySelectorAll('.rise > span').forEach(function (el) {
      el.parentNode.parentNode.classList.add('in');
    });
    root.querySelectorAll('[data-announce-scroll]').forEach(function (el) {
      el.classList.add('is-out');
    });
    root.querySelectorAll('.worm').forEach(function (el) {
      el.classList.add('run');
    });
    root.querySelectorAll('.pigeonholes').forEach(function (el) {
      ['f1', 'f2', 'f3'].forEach(function (c) { el.classList.remove(c); });
    });
  }

  document.addEventListener('shopify:section:load', function (e) { wakeUp(e.target); });
  document.addEventListener('shopify:section:select', function (e) { wakeUp(e.target); });
  document.addEventListener('shopify:block:select', function (e) { wakeUp(e.target); });
})();
